<template>
    <div class="" v-if="data">
        <h2>Внеучебные достижения кадет</h2>
        <table>
            <tr>
                <td>Количество участников торжественного марша 7 ноября на Красной площади<sup>6</sup></td>
                <td>{{data.pupils7November}}</td>
            </tr>
            <tr>
                <td>Количество участников Парада Кадетского движения Москвы «Не прервется связь поколений»  6 мая на Поклонной горе <sup>6</sup></td>
                <td>{{data.pupilsGenerationMay}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров конкурсов проектных и учебно-исследовательских работ, проводимых учреждениями и организациями, участвующими в Проекте</td>
                <td>{{data.pupilsWinners}}</td>
            </tr>
            <tr>
                <td>Количество участников Парада 9 мая на Красной площади</td>
                <td>{{data.pupils9May}}</td>
            </tr>
        </table>
        <div class="info-desc">
            <sup>6</sup> участники марша, в том числе запасные, волонтеры, участники концертной части
            <sup>7</sup> в соответствии с Перечнем конкурсов на учебный год
        </div>
    </div>
</template>


<script>
    import Request from 'superagent';

    export default{
        data(){
            return {
                data:false
            };
        },


        created(){
            this.getData();
        },


        methods:{
            getData(){
                var $this = this;
                var path = this.$store.state.api+ this.$store.state.apiCadetConcurs +"?eoId="+this.$store.state.eoId;
                Request
                    .get(path)
                    .then((res)=>{
                        if(res.status == 200){
                            if(res.body.result == "success"){
                                $this.data = res.body.data;
                            }
                        }
                    });
            },
        }
    }
</script>


<style>

</style>
